import PropTypes from 'prop-types';
export var defaultProps = {
  gotham: false,
  chronicle: false,
  italic: false,
  uppercase: false,
  light: false
};
export var propTypes = {
  children: PropTypes.node,

  /** Font size, 1=smallest, 5=biggest */
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Use Gotham font. Font is inherited if not specified. */
  gotham: PropTypes.bool,

  /** Use Chronicle font. Font is inherited if not specified. */
  chronicle: PropTypes.bool,

  /** Bold styling */
  bold: PropTypes.bool,

  /** Italic styling */
  italic: PropTypes.bool,

  /** Turn text uppercase and spaces out letters. */
  uppercase: PropTypes.bool,

  /** Set text to a light gray color */
  light: PropTypes.bool,

  /** Set text to a color defined by base-styles (overrides light) */
  color: PropTypes.string
};